// extracted by mini-css-extract-plugin
export default {"primaryColor":"#1c75bc","primaryColorWithAlpha":"rgba(28,117,188,.1019607843)","mainBgColor":"#fff","secondBgColor":"#f5f5f5"};